// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3185":"bfde99e5bba4af6c","3921":"29d4598e7d9cb6ca"}[chunkId] + ".css";
};